export class DeviceDetector {
  isMobile(): boolean {
    return this.isIOSDevice() || /Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }

  isAppleDevice(): boolean {
    return this.isIOSDevice() || /Macintosh|MacIntel|MacPPC|Mac68K/i.test(navigator.userAgent);
  }

  isIOSDevice(): boolean {
    return /iPhone|iPad|iPod/i.test(navigator.userAgent);
  }
}
